exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.document-link[data-v-5d998f69] {\n  color: #557CEF;\n}", ""]);

// exports
